import React from 'react';
import BookContainer from '../components/BookContainer';

const Books = () => (
  <>
    <BookContainer />
  </>
);

export default Books;
